import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UserRole } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loading = false;

  value = Math.floor(Math.random() * (50 - 30) + 30);

  constructor(private msalService: MsalService,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    setTimeout(() => {
      this.value += Math.floor(Math.random() * (50 - 30) + 30);
    }, 2000);

    this.authService.isLoggedInRedirect$.subscribe(resp => {
      if (resp) {
        this.router.navigate(['home']);
      }
    });
  }

  login() {
    this.msalService.loginRedirect();
  }

  isLoggedIn() {
    return this.msalService.instance.getActiveAccount() != null;
  }
}
